<div matRipple class="banner-button">
  <div class="tag mat-headline-2" *ngIf="tag">{{ tag }}</div>

  <div class="radio" *ngIf="radioButton">
    <span class="radio-icon">
      <span class="dot"></span>
    </span>
  </div>

  <div class="icon-prefix" [ngClass]="iconPrefixAlignment">
    <ng-content select="x-streamline-icon[xIconPrefix]"></ng-content>
    <ng-content select="fa-icon[xIconPrefix]"></ng-content>
  </div>

  <div class="content-wrap">
    <div class="content">
      <div class="label" *ngIf="label">{{ label }}</div>
      <ng-content></ng-content>

      <div class="instructions mat-caption py-2 px-3 mt-3 rounded-pill">
        <ng-content select="[xIntruction]"></ng-content>
      </div>
    </div>

    <div class="actions">
      <ng-content select="[xAction]"></ng-content>
    </div>
  </div>

  <div class="icon-suffix" [ngClass]="iconSuffixAlignment">
    <ng-content select="x-streamline-icon[xIconSuffix]"></ng-content>
    <ng-content select="fa-icon[xIconSuffix]"></ng-content>
  </div>

  <x-loader *ngIf="loading"></x-loader>
</div>
